import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ability from '@/libs/acl/ability'

export default function useStoresList(){

    const toast = useToast()

    const refStoreListTable = ref(null)
    
    // Stores table contains column Store Code / Store Name / Status / Created at / Action
    const tableColumns = [
        { key: 'id', sortable: true },
        { key: 'name',stickyColumn:true , sortable: true },
        { key: 'address', sortable: true },
        { key: 'phone', sortable: true },
        { key: 'email', sortable: true },
        { key: 'website', sortable: true},
        { key: 'working_hour'},
        { key: 'facebook_link', sortable: true},
        { key: 'ig_link', sortable: true},
        { key: 'is_active', label:'STATUS'},
        { key: 'actions'}
    ]
    const perPage = ref(10)
    const totalStores = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)

    const dataMeta = computed(() => {
        const localItemsCount = refStoreListTable.value ? refStoreListTable.value.localItems.length : 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1: 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalStores.value,
        }
    })

    const refetchData = () =>{
        refStoreListTable.value.refresh()
    }

    watch([currentPage, perPage, searchQuery], () => {
        refetchData()
    })

    const fetchStores = (ctx, callback) => {

        store.dispatch('setting-store/fetchStores', {
            q: searchQuery.value,
            perPage: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
        })
        .then(response => {
            const { stores, total } = response.data
            callback(stores)
            totalStores.value = total
        })
        .catch(() => {
            toast({
                component: ToastificationContent,
                props: {
                    title: 'Error fetching stores list',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger'
                },
            })
        })

    }

    return {
        fetchStores,
        tableColumns,
        perPage,
        currentPage,
        totalStores,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refetchData,
        refStoreListTable,
        ability

    }


}